<div class="drill-data">
  <h2 mat-dialog-title>
    Filtered by: {{ data.category }} <ng-container *ngIf="data.series"> and {{ data.series }}</ng-container>
    <button mat-icon-button matTooltip="Close" (click)="close()">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <ng-container *ngIf="drillData$ | async as drillData">
      <app-reporting-builder-data-table
        [fields]="data.fields"
        [columns]="data.columns"
        [options]="data.options"
        [data]="drillData"
        [rootContainerCss]="{ height: '100%' }"
        (pageChanged)="onPageChanged($event)"
        (sortChanged)="onSortChanged($event)"
      ></app-reporting-builder-data-table>
    </ng-container>
  </mat-dialog-content>
</div>
